// The redesigned site header's links (approved Sept 26 2026 package), mapped from the
// reference's static paths to the production routes (no trailing slashes).

/** Desktop bar, in order: How it works · Businesses · Venues · Pricing. */
export const HEADER_NAV = Object.freeze([
  { label: 'How it works', to: '/how-it-works' },
  { label: 'Businesses', to: '/for-businesses' },
  { label: 'Venues', to: '/for-venues' },
  { label: 'Pricing', to: '/pricing' },
]);

/** Mobile menu panel, in order (the reference's list; its "Log in on Tappd" is the account block). */
export const MENU_NAV = Object.freeze([
  ...HEADER_NAV,
  { label: 'Local deals', to: '/local-deals-near-me' },
  { label: 'Find a placement', to: '/venues' },
  { label: 'Free listing', to: '/free-listing' },
  { label: 'Our story', to: '/our-story' },
]);

/**
 * "Get started": the header's audience chooser (GetStartedMenu, and the same rows at the top
 * of the mobile Menu panel), upgrade brief §2.1. One row per audience, in this order:
 * `key` (picks the icon), `label`, `text` (one short, true line) and `to` (the audience's
 * page). Copy only states what the product does today: advertisers pay, venues get the
 * coasters free, guests claim with just an email.
 */
export const GET_STARTED_CHOICES = Object.freeze([
  {
    key: 'business',
    label: 'Advertise my business',
    text: 'Your offer on coasters at local tables.',
    to: '/for-businesses',
  },
  {
    key: 'venue',
    label: 'Get free coasters for my venue',
    text: 'Free coasters, paid for by local advertisers.',
    to: '/for-venues',
  },
  {
    key: 'guest',
    label: 'Find deals near me',
    text: 'Browse local offers. Claim one with just an email.',
    to: '/local-deals-near-me',
  },
]);

/** The right margin note, "say hello ↗". */
export const SAY_HELLO_HREF = 'mailto:hello@tappd.app';

/** "/pricing/" and "/Pricing" count as "/pricing" for aria-current. */
export function normalisePath(pathname) {
  const p = String(pathname || '/').toLowerCase().replace(/\/+$/, '');
  return p || '/';
}

/** aria-current="page" for the link to the current path only (exact match, no parents). */
export function currentProps(pathname, to) {
  return normalisePath(pathname) === normalisePath(to) ? { 'aria-current': 'page' } : {};
}

/**
 * Pages whose top is not the paper canvas yet, where the navy margin notes would be
 * unreadable (and "say hello" would sit on the page's own decoration). Empty since the
 * Our Story redesign (the legacy dark story page only shows with SLOT_MODEL off, under the
 * legacy header); add a path here if such a page comes back.
 */
export const MARGIN_NOTE_HIDDEN_PATHS = Object.freeze([]);

/** False on the pages in MARGIN_NOTE_HIDDEN_PATHS (and anything under them). */
export function marginNotesShown(pathname) {
  const p = normalisePath(pathname);
  return !MARGIN_NOTE_HIDDEN_PATHS.some((hidden) => p === hidden || p.startsWith(`${hidden}/`));
}
